import GiftCardPayForm from './GiftCardPayForm';

export default GiftCardPayForm;
